import React from 'react';

interface HeaderProps {
}
interface HeaderState {
  menuActive: boolean;
}

class Header extends React.Component<HeaderProps, HeaderState> {
  constructor(props:HeaderProps) {
    super(props);
    this.state = { menuActive: false };
  }

  render() {
  return <><nav className="navbar is-transparent" role="navigation" aria-label="main navigation">
  <div className="navbar-brand">
    <a className="navbar-item" href="/index.html">
      <img className="s-logo" src="/img/wordmark.png" style={{ width: "15rem", maxHeight: "unset" }} />
    </a>

    <a role="button" className={`navbar-burger burger ${this.state.menuActive && 'is-active'}`} aria-label="menu" aria-expanded="false" data-target="navbarBasicExample"
        onClick={() => this.setState({ menuActive: !this.state.menuActive })}>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div className={`navbar-menu ${this.state.menuActive && 'is-active'}`}>
    <div className="navbar-start"></div>
    <div className="navbar-end">
        <div className="navbar-item is-arrowless"><a className="navbar-link button is-arrowless" href="https://get.sheet.rocks/support/home">
            Support
          </a></div>
        <div className="navbar-item is-arrowless"><a className="button is-primary" href="/login">
            Login
        </a></div>
    </div>
  </div>
</nav>
</>
}
}

export default Header;
